import { template as template_683aedf9e9f5480fa5884fd6a99de983 } from "@ember/template-compiler";
import ButtonPowerSelect from 'eflex/components/button-power-select';
import { get } from '@ember/helper';
export default template_683aedf9e9f5480fa5884fd6a99de983(`
<ButtonPowerSelect
  @options={{@options}}
  @triggerClass={{@triggerClass}}
  @placeholder={{@placeholder}}
  @disabled={{@disabled}}
  @extra={{@extra}}
  @searchEnabled={{@searchEnabled}}
  @searchField={{@searchField}}
  @ariaDescribedBy={{@ariaDescribedBy}}
  @onChange={{@onChange}}
  ...attributes
as |option select|>
  {{#if (has-block)}}
    {{yield option select}}
  {{else}}
    {{#if @optionLabelPath}}
      {{get option @optionLabelPath}}
    {{else}}
      {{option}}
    {{/if}}
  {{/if}}
</ButtonPowerSelect>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
